import { Nullable } from "../types/Nullable";

export const mapNullableToUndefined = <T>(value?: Nullable<T>): T | undefined => {
    if (value === null) {
        return undefined;
    }

    return value;
};
